import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class PermissionGuard implements CanActivate {
  constructor(private router: Router, private authService: AuthService) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot) {
    if (route?.data?.requiredPermissions && route.data.requiredPermissions.length !== 0) {
      for (const permission of route.data.requiredPermissions) {
        if (!this.authService.checkPermission(permission)) {
          this.authService.accessDeniedData$.next({ url: route.url.toString(), permission });
          void this.router.navigate(['access-denied']);
          return false;
        }
      }
    }

    return true;
  }
}
